import { normalize } from 'normalizr'
import { Schemas } from 'redux-modules/schema'
import { updateEntities, deleteEntity } from 'redux-modules/entity'

import api from 'api'

const CREATE_REQUEST = 'realhub/orderBundleItem/CREATE_REQUEST'
const CREATE_SUCCESS = 'realhub/orderBundleItem/CREATE_SUCCESS'
const CREATE_FAILURE = 'realhub/orderBundleItem/CREATE_FAILURE'
const UPDATE_REQUEST = 'realhub/orderBundleItem/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'realhub/orderBundleItem/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'realhub/orderBundleItem/UPDATE_FAILURE'
const DELETE_REQUEST = 'realhub/orderBundleItem/DELETE_REQUEST'
const DELETE_SUCCESS = 'realhub/orderBundleItem/DELETE_SUCCESS'
const DELETE_FAILURE = 'realhub/orderBundleItem/DELETE_FAILURE'

// Initial State
const initialState = {
  creating: false,
  updating: false,
  deleting: false,
  errors: [],
}

// Actions
export function createRequest(){
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess(){
  return {
    type: CREATE_SUCCESS,
  }
}

export function createFailure(errors = []){
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function updateRequest(){
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess(){
  return {
    type: UPDATE_SUCCESS,
  }
}

export function updateFailure(errors = []){
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

export function deleteRequest(){
  return {
    type: DELETE_REQUEST,
  }
}

export function deleteSuccess(){
  return {
    type: DELETE_SUCCESS,
  }
}

export function deleteFailure(errors = []){
  return {
    type: DELETE_FAILURE,
    errors,
  }
}

// Helper Functions
const handleError = errors => errors || ['Something went wrong']

// Action Creators
export function createOrderBundleItem(orderBundleItem, options, callback){
  const config = {
    method: 'POST',
    body: JSON.stringify({
      order_bundle_item: orderBundleItem,
    }),
  }

  return (dispatch) => {
    // Set Loading
    dispatch(createRequest())

    const promise = api(`/admin/order_bundles/${orderBundleItem.order_bundle_id}/items.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.ORDER_BUNDLE_ITEM)
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess())

        if (callback) callback(json)
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(createFailure(errors))
      })

    return promise
  }
}

export function updateOrderBundleItem(orderBundleItem, options){
  const config = {
    method: 'PUT',
    body: JSON.stringify({
      order_bundle_item: orderBundleItem,
    }),
  }

  return (dispatch) => {
    // Set Loading
    dispatch(updateRequest())

    const { id, order_bundle_id } = orderBundleItem
    const promise = api(`/admin/order_bundles/${order_bundle_id}/items/${id}.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.ORDER_BUNDLE_ITEM)
        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess())
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(updateFailure(errors))
      })

    return promise
  }
}

export function deleteOrderBundleItem(orderBundleItem, options){
  const config = {
    method: 'DELETE',
  }

  return (dispatch) => {
    // Set Loading
    dispatch(updateRequest())

    const { id, order_bundle_id } = orderBundleItem
    const promise = api(`/admin/order_bundles/${order_bundle_id}/items/${id}.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.ORDER_BUNDLE_ITEM)
        dispatch(deleteEntity(normalizedJson))
        dispatch(updateSuccess())
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(updateFailure(errors))
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case CREATE_REQUEST:
      return Object.assign({}, state, {
        creating: true,
      })
    case CREATE_SUCCESS:
      return Object.assign({}, state, {
        creating: false,
        errors: [],
      })
    case CREATE_FAILURE:
      return Object.assign({}, state, {
        creating: false,
        errors: action.errors,
      })
    case UPDATE_REQUEST:
      return Object.assign({}, state, {
        updating: true,
      })
    case UPDATE_SUCCESS:
      return Object.assign({}, state, {
        updating: false,
        errors: [],
      })
    case UPDATE_FAILURE:
      return Object.assign({}, state, {
        updating: false,
        errors: action.errors,
      })
    case DELETE_REQUEST:
      return Object.assign({}, state, {
        deleting: true,
      })
    case DELETE_SUCCESS:
      return Object.assign({}, state, {
        deleting: false,
        errors: [],
      })
    case DELETE_FAILURE:
      return Object.assign({}, state, {
        deleting: false,
        errors: action.errors,
      })
    default:
      return state
  }
}
